export default __webpack_public_path__ + "static/media/ELK.ebff0dde.png";